import { useScrollLock } from 'usehooks-ts';

export default function LockBodyDummy() {
    useScrollLock();
    return <></>;
}
